import React from "react";
import { Icon, ospThemes } from "@ospweb/sdk-ui";
import { cn } from "utils";
import { PaymentMethodSelectorProps, PaymentMethod } from "./types";
import Translations from "@translate/components/Payment/PaymentContent/PaymentMethodSelector";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

export const PaymentMethodSelector: React.FC<PaymentMethodSelectorProps> = ({
  currentMethod,
  onMethodChange,
  disabled,
}) => {
  const handleMethodClick = (method: PaymentMethod) => {
    if (method !== currentMethod) {
      onMethodChange(method);
    }
  };
  const PayMethodList = [
    {
      name: I18n.t("Paypal"),
      icon: "paypal",
      method: "paypal",
    },
    {
      name: I18n.t("Crypto"),
      icon: "wallet",
      method: "wallet",
    },
  ];
  return (
    <div className="flex flex-col gap-3 w-full">
      {PayMethodList.map((item) => {
        return (
          <div
            data-openreplay-label="PaymentContent · PaymentMethodSelector · div"
            key={item.method}
            className={cn(
              "flex-1 flex flex-col items-center justify-center gap-1 p-6 h-17 rounded-xl cursor-pointer",
              currentMethod === item.method
                ? "bg-background_white_overlay10 border border-content_primary"
                : "border border-background_white_overlay20",
            )}
            onClick={() => {
              if (disabled) {
                return;
              }
              handleMethodClick(item.method as PaymentMethod);
            }}
          >
            <div className="flex items-center gap-1 h-5 justify-center">
              <Icon
                name={item.icon}
                size={20}
                color={ospThemes.colors.content_primary}
              />
              <div className="body_l text-content_primary whitespace-nowrap">
                {item.name}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
